import { ContainerResponseDto } from '@planning/app/api'
import { EventTypes } from '@planning/messages/eventsTypes'
import { GetContainerByIdQuery, GetContainersByVisitIdQuery } from '@planning/messages/queries'
import { GetContainersByIdsQuery } from '@planning/messages/queries/getContainersByIdsQueryHandler'
import { IEvent, IMessageBus } from '@tom-ui/utils'
import { action, makeObservable } from 'mobx'
import { ItemStore } from '../base/ItemStore'
import { ContainerItem, IContainerItem } from './ContainerItem'

// TODO: [north] UT
export class ContainerItemStore extends ItemStore<ContainerResponseDto, IContainerItem> {
  fetchedVisitIds: Set<number> = new Set()

  constructor(private messageBus: IMessageBus) {
    super((key, data) => new ContainerItem(key, data), {
      messageBus,
      fetchFunc: (id: number) => new GetContainerByIdQuery(id),
      bulkFetchFunc: (ids: number[]) => new GetContainersByIdsQuery(ids),
    })
    makeObservable(this, {
      receiveContainersMessage: action,
      receiveContainerUpsertedEventMessage: action,
    })

    messageBus.subscribeEvent(GetContainersByVisitIdQuery.type, this.receiveContainersMessage)
    messageBus.subscribeEvent(GetContainersByIdsQuery.type, this.receiveContainersMessage)
    messageBus.subscribeEvent(GetContainerByIdQuery.type, this.receiveContainerUpsertedEventMessage)
    messageBus.subscribeEvent(
      EventTypes.ContainerUpsertedEvent,
      this.receiveContainerUpsertedEventMessage,
    )
  }

  fetchByVisitId = async (visitId: number) => {
    this.fetchByVisitIds([visitId])
  }

  fetchByVisitIds = async (visitIds: number[]) => {
    const toBeFetchedIds = visitIds.filter(visitId => !this.fetchedVisitIds.has(visitId))
    if (!toBeFetchedIds.length) return

    for (const id of toBeFetchedIds) {
      this.fetchedVisitIds.add(id)
    }

    await this.messageBus.dispatchQuery(new GetContainersByVisitIdQuery(toBeFetchedIds))
  }

  receiveContainersMessage = (event: IEvent<ContainerResponseDto[]>): void => {
    console.log('ContainerItemStore received containers message', event)
    if (event.payload) {
      this.upsertBulk(event.payload)
    }
  }

  receiveContainerUpsertedEventMessage = (event: IEvent<ContainerResponseDto>): void => {
    if (event.payload) {
      this.upsert(event.payload)
    }
  }
}
